import React from 'react';

// Title on the left, actions on the right. Subtitles show from md up only.
const PageHeader = ({ title, subtitle, actions }) => (
  <div className="flex items-center justify-between gap-3 min-h-[2.5rem]">
    <div className="min-w-0">
      <h1 className="text-xl md:text-2xl font-semibold text-slate-900 truncate">{title}</h1>
      {subtitle && <p className="hidden md:block text-sm text-slate-500 mt-1">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
  </div>
);

export default PageHeader;
